import React from "react";
import { Link } from "react-router-dom";
import { Api } from "./../app-controller.js";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
//import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";

class RepresentanteInscription extends React.Component {
  constructor(props) {
    super(props);

    this.handleDepartamentos = this.handleDepartamentos.bind(this);
    this.handleMunicipios = this.handleMunicipios.bind(this);
    this.handleRepresentante = this.handleRepresentante.bind(this);
    this.addRep = this.addRep.bind(this);
    this.removeRep = this.removeRep.bind(this);
    this.validateIdentificationNumber =
      this.validateIdentificationNumber.bind(this);

    this.state = {
      nivelUsuario: localStorage.nivel_actual,
      representante_legal: {
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        direccion: "",
        tipo_documento_id: "", //tipo identificacion
        numero_identificacion: "",
        telefono_celular: "",
        correo_electronico: "",
        departamento_id: "",
        municipio_id: "",
      },
      options_identification: {
        tipo_identificacion: Api.loadCatalogue("cat_tipo_documento"),
      },
      options_locations: Api.loadCatalogue("locations"),
    };
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let identificacion = Api.loadCatalogue("cat_tipo_documento");
    let ids = [];
    for (let id in identificacion) {
      if (identificacion[id].id === "1" || identificacion[id].id === "2") {
        ids.push(identificacion[id]);
      }
    }
    this.setState({ options_identification: { tipo_identificacion: ids } });
  }

  addRep(e) {
    let data = Api.serialize(document.getElementById("frmRep"));
    Api.loading(1);
    Api.fetch("app/createRepresentante", data, "POST").then((data) => {
      Swal.fire({
        title: "Alta de representante legal",
        text: data.message,
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Continuar",
      }).then(() => {
        window.location.href="/";
      });
    }).catch((error) => {
      error.json().then((e) => {
        Swal.fire({
          title: "Alta de representante legal",
          text: e.message,
          icon: "warning",
        });
      });
    });
  }

  removeRep(e) {
    let representantes = [...this.state.representantes];
    representantes.splice(e.target.id, 1);
    this.setState({ representantes: representantes });
  }

  handleDepartamentos(e) {
    let depa = this.state.options_locations.departamentos.find(
      (d) => d.id.toString() === e.target.value
    );
    this.setState({
      departamento_id: e.target.value,
      departamento_name: depa.name,
    });
    this.handleLatLong(depa.name);
  }

  handleMunicipios(e) {
    let muni = this.state.options_locations.municipios.find(
      (d) => d.id.toString() === e.target.value
    );
    this.setState({ municipio_id: e.target.value, municipio_name: muni.name });
    if (this.state.departamento_id !== "") {
      this.handleLatLong(muni.name + "" + this.state.departamento_name);
    }
  }

  handleRepresentante(e) {
    let rep = { ...this.state.representante_legal }; //hacemos una copia del objeto
    if (
      e.target.name === "nombres" ||
      e.target.name === "apellido_paterno" ||
      e.target.name === "apellido_materno"
    ) {
      rep[e.target.name] = e.target.value.toUpperCase();
    } else if (e.target.name === "numero_identificacion") {
      // if (this.validateIdentificationNumber(e.target.value)) {
      rep[e.target.name] = e.target.value;
      // }
    } else {
      rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
    }

    this.setState({ representante_legal: rep });
  }

  validateIdentificationNumber(char) {
    let regex = /^\d+$/;
    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/solicitud/inscripcion-representante">Solicitud</Link>
          </li>
          <li className="breadcrumb-item active">
            Inscripción Representante Legal
          </li>
        </ol>
        <h1 className="page-header">
          Solicitud de inscripción de representante legal
        </h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form id="frmRep" style={{ margin: "2.5%" }}>
                  {/*  <fieldset> */}
                  {/*  <h3>Alta de representante legal</h3> */}
                  {/*  <hr></hr> */}
                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Tipo de Identificación: </label>
                      <span className="text-danger"> *</span>
                      <select
                        onChange={this.handleRepresentante}
                        name="tipo_documento_id"
                        className="form-control m-b-5"
                        value={this.state.representante_legal.tipo_documento_id}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_identification.tipo_identificacion.map(
                          (option, index) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Número de Identificación: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="numero_identificacion"
                        maxLength="50"
                        value={
                          this.state.representante_legal.numero_identificacion
                        }
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese número de identificación "
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Dirección: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="direccion"
                        value={this.state.representante_legal.direccion}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese la dirección "
                        required
                      />
                    </div>
                  </div>
                  <div
                    className="form-group col-md-12"
                    style={{ textAlign: "right" }}
                  >
                    <hr />
                    <div onClick={this.addRep} className="btn btn-success">
                      Generar
                    </div>
                  </div>

                  {/*   </fieldset> */}
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default RepresentanteInscription;
